// extracted by mini-css-extract-plugin
export var backdropBlur = "_jk-0";
export var contentCard = "_jk-5";
export var frame = "_jk-2";
export var image = "_jk-4";
export var imagePane = "_jk-3";
export var modal = "_jk-1";